<template>
  <div class="bttn" @click="open">{{ $t('vue2.createroom_button.create_room')}}</div>
</template>

<script>
  import eventbus from '../../eventbus'
  export default {
    methods: {
      open () {
        eventbus.createCalendarsType = 'room'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CreateRoomsButton.vue?f4c00620